<div class="card-container" [class]="{
  'large-card': size() === CollapsibleCardSize.large,
  'medium-card': size() === CollapsibleCardSize.medium,
  'small-card': size() === CollapsibleCardSize.small,
  }">
  <div class="card-header" (click)="toggleCollapsed()">
    <mat-icon [svgIcon]="isCollapsed() ? 'chevron-down' : 'chevron-up'"></mat-icon>
    <div class="card-titles">
      <div class="font-title-small">{{ titleText() }}</div>
      <div [hidden]="!subtitle()" class="font-label-large font-secondary">{{ subtitle() }}</div>
    </div>
  </div>
  @if (!isCollapsed()) {
    <ng-content></ng-content>
  }
</div>
